import { API_PREFIX_V1 } from "../constants";

// App
export const ROUTE_DASHBOARD = `/dashboard`;
export const ROUTE_MANAGE_STAFF = `/manage-staff`;
export const ROUTE_MANAGE_DEPARTMENT = `/manage-department`;
export const ROUTE_MANAGE_SUB_DEPARTMENT = `/manage-sub-department`;
export const ROUTE_MANAGE_PROJECT = `/manage-project`;
export const ROUTE_MILESTONES = `/milestones`;
export const ROUTE_MANAGE_BILLING_CYCLE = `/manage-billing-cycle`;
export const ROUTE_MANAGE_VENDOR = `/manage-vendor`;
export const ROUTE_BILLING_SUMMARY = `/billing-summary`;
export const ROUTE_MANAGE_ACCOUNT = `/manage-client`;
export const ROUTE_MANAGE_FOREX = `/manage-forex`;

export const API_GET_STAFF_LIST = `${API_PREFIX_V1}staffs/staff-list`;
export const API_CREATE_STAFF = `${API_PREFIX_V1}staffs/create-staff`;
export const API_DELETE_STAFF = `${API_PREFIX_V1}staffs/delete-staff/`;
export const API_UPDATE_STAFF = `${API_PREFIX_V1}staffs/update-staff/`;
export const API_GET_ALL_STAFF_LIST = `${API_PREFIX_V1}staffs/get-staff-list`;
export const API_GET_STAFF_DETAILS = `${API_PREFIX_V1}staffs/get-staff-by-Id`;
export const API_STAFF_BULK_IMPORT = `${API_PREFIX_V1}staffs/staff-bulk-import`;
export const API_GET_STAFF_SALARY_INFO = `${API_PREFIX_V1}staffs/staff-salary/`;
export const API_CREATE_STAFF_SALARY_INFO = `${API_PREFIX_V1}staffs/staff-salary-revision`;
export const API_UPDATE_STAFF_SALARY_INFO = `${API_PREFIX_V1}staffs/staff-salary-revision/`;

export const API_GET_DEPARTMENT_LIST = `${API_PREFIX_V1}departments/departments-list`;
export const API_CREATE_DEPARTMENT = `${API_PREFIX_V1}departments/create-departments`;
export const API_DELETE_DEPARTMENT = `${API_PREFIX_V1}departments/delete-department/`;
export const API_UPDATE_DEPARTMENT = `${API_PREFIX_V1}departments/update-department/`;
export const API_GET_ALL_DEPARTMENT_LIST = `${API_PREFIX_V1}departments/get-department-list`;

export const API_CREATE_SUB_DEPARTMENT = `${API_PREFIX_V1}departments/sub-department/create`;
export const API_GET_SUB_DEPARTMENT_LIST = `${API_PREFIX_V1}departments/sub-departments/list`;
export const API_DELETE_SUB_DEPARTMENT = `${API_PREFIX_V1}departments/delete-sub-department/`;
export const API_UPDATE_SUB_DEPARTMENT = `${API_PREFIX_V1}departments/update-sub-department/`;
export const API_GET_SUBDEPARTMENTS_BY_DEPARTMENT = `${API_PREFIX_V1}departments/get-sub-departments/`;

export const API_GET_ALL_PROJECT_LIST = `${API_PREFIX_V1}projects/get-project-list`;
export const API_GET_PROJECT_DETAILS = `${API_PREFIX_V1}projects/get-project/`;
export const API_GET_PROJECT_LIST = `${API_PREFIX_V1}projects/projects-list`;
export const API_DELETE_PROJECT = `${API_PREFIX_V1}projects/delete-project/`;
export const API_CREATE_PROJECT = `${API_PREFIX_V1}projects/create-projects`;
export const API_UPDATE_PROJECT = `${API_PREFIX_V1}projects/update-project/`;
export const API_PROJECT_BULK_IMPORT = `${API_PREFIX_V1}projects/project-bulk-import`;

// Milestones (under projects)
const MILESTONES_BASE = `${API_PREFIX_V1}projects/milestones`;
export const API_GET_MILESTONES_BY_PROJECT = `${MILESTONES_BASE}`;
export const API_GET_MILESTONE = `${MILESTONES_BASE}/`;
export const API_CREATE_MILESTONE = MILESTONES_BASE;
export const API_UPDATE_MILESTONE = `${MILESTONES_BASE}/`;
export const API_PATCH_MILESTONE_ORDER = `${MILESTONES_BASE}/`;
export const API_DELETE_MILESTONE = `${MILESTONES_BASE}/`;
export const API_MILESTONES_LIST = `${MILESTONES_BASE}/list`;

export const API_GET_BILLING_CYCLE_LIST = `${API_PREFIX_V1}billing-cycle/billing-cycle-list`;
export const API_CREATE_BILLING_CYCLE = `${API_PREFIX_V1}billing-cycle/create-billing-cycle`;
export const API_UPDATE_BILLING_CYCLE = `${API_PREFIX_V1}billing-cycle/update/`;
export const API_DELETE_BILLING_CYCLE = `${API_PREFIX_V1}billing-cycle/delete-billing-cycle/`;
export const API_GET_BILLING_CYCLE_SUMMARY = `${API_PREFIX_V1}billing-cycle/billing-cycle-summary`;
export const API_GET_BILLING_DETAILS = `${API_PREFIX_V1}billing-cycle/billing-cycle-details`;

export const API_GET_ALL_VENDOR_LIST = `${API_PREFIX_V1}vendor/get-vendor-list`;
export const API_GET_VENDOR_LIST = `${API_PREFIX_V1}vendor/vendor-list`;
export const API_CREATE_VENDOR = `${API_PREFIX_V1}vendor/create-vendor`;
export const API_UPDATE_VENDOR = `${API_PREFIX_V1}vendor/update-vendor/`;

export const API_GET_ALL_ACCOUNTS_LIST = `${API_PREFIX_V1}accounts/get-account-list`;
export const API_GET_ACCOUNT_LIST = `${API_PREFIX_V1}accounts/account-list`;
export const API_CREATE_ACCOUNT = `${API_PREFIX_V1}accounts/create-account`;
export const API_UPDATE_ACCOUNT = `${API_PREFIX_V1}accounts/update-account/`;
export const API_DELETE_ACCOUNT = `${API_PREFIX_V1}accounts/delete-account/`;
export const API_GET_ACCOUNT_LIST_BY_ENTITY = `${API_PREFIX_V1}accounts/get-accounts/`;

export const API_GET_ACTIVITY_LOG = `${API_PREFIX_V1}activity-log/`;
export const API_GET_DOCUMENTS = `${API_PREFIX_V1}documents/get-document-list/`;
export const API_GET_DOCUMENT_SIGNED_URL = `${API_PREFIX_V1}documents/get-signed-url/`;

export const API_GET_STAFF_ALLOCATION = `${API_PREFIX_V1}staff-assignment/`;
export const API_CREATE_STAFF_ASSIGNMENT = `${API_PREFIX_V1}staff-assignment/create-staff-assignment`;
export const API_UPDATE_STAFF_ASSIGNMENT = `${API_PREFIX_V1}staff-assignment/update-staff-assignment`;
export const API_GET_STAFF_ASSIGNMENT_SUMMARY = `${API_PREFIX_V1}staff-assignment/staff-assignment-summary`;

export const API_COMMON_GET_BY_MODULE = (module: string) =>`${API_PREFIX_V1}master/${module}`;

export const API_GET_FOREX_LIST = `${API_PREFIX_V1}master/currency/exchange-rate/list`;
export const API_ADD_FOREX = `${API_PREFIX_V1}master/currency/exchange-rate`
export const API_UPDATE_FOREX = `${API_PREFIX_V1}master/update-currency-exchange-rate/`